import { JSONType } from "Typings/Global";
import { WeeklyTech } from "./@types";


export const parseWeeklyTech = (data: JSONType): WeeklyTech => {
    const {
        id, created, updated, isPublished, title, description, keywords, short_description, _coverPicture, body, views, authorId,
        publishDate, slug, tagIds, tags, isFeatured, og_title
    } = data;
    return {
        id, created, updated, isPublished, title, description, keywords, shortDescription: short_description, coverPicture: _coverPicture,
        body, views, authorId, publishDate, slug, tagIds, tags, isFeatured, ogTitle: og_title
    }
}

export const weeklyTechFormToRequestDataMapping = (data: Partial<WeeklyTech>) => {
    const { id, title, description, keywords, shortDescription, coverPicture, body, authorId, tagIds, slug, ogTitle } = data;
    return {
        id, title, description, keywords, short_description: shortDescription, _coverPicture: coverPicture,
        body, authorId, tagIds, slug, og_title: ogTitle
    }
}
